<template>
  <v-layout>
    <v-flex xs12>
      <v-card class="elevation-3 py-2">
        <v-card-title>
          <h4>Используемый ассортимент</h4>
        </v-card-title>
        <v-expansion-panels popout multiple>
          <v-expansion-panel
            v-for="item in this.organizationUsers"
            :key="item.userId"
          >
            <v-expansion-panel-header>
              <v-layout>
                <v-flex xs2 md1>
                  <v-icon color="primary">{{ icons.tooltipAccount }}</v-icon>
                </v-flex>
                <v-flex xs8>{{ item.email }} ({{ item.name }})</v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <v-layout row wrap>
                  <!-- v-if="item.organizationUsePharmacy" -->
                  <v-switch
                    color="primary"
                    class="pa-2 mt-n1 mb-n6"
                    label="Аптечный"
                    :input-value="item.settings.usePharmacy"
                    @change="
                      (value) => changeTypes(item.userId, 'usePharmacy', value)
                    "
                  ></v-switch>
                  <!-- v-if="item.organizationUseDietarySupplement" -->
                  <v-switch
                    color="primary"
                    class="pa-2 mt-n1 mb-n6"
                    label="БАД"
                    :input-value="item.settings.useDietarySupplement"
                    @change="
                      (value) =>
                        changeTypes(item.userId, 'useDietarySupplement', value)
                    "
                  ></v-switch>
                  <!-- v-if="item.organizationUseOptics" -->
                  <v-switch
                    color="primary"
                    class="pa-2 mt-n1 mb-n6"
                    label="Оптика"
                    :input-value="item.settings.useOptics"
                    @change="
                      (value) => changeTypes(item.userId, 'useOptics', value)
                    "
                  ></v-switch>
                  <!-- v-if="item.organizationUseMedicalEquipment" -->
                  <v-switch
                    color="primary"
                    class="pa-2 mt-n1 mb-n6"
                    label="Медтехника"
                    :input-value="item.settings.useMedicalEquipment"
                    @change="
                      (value) =>
                        changeTypes(item.userId, 'useMedicalEquipment', value)
                    "
                  ></v-switch>
                  <!-- v-if="item.organizationUseMedicalProducts" -->
                  <v-switch
                    color="primary"
                    class="pa-2 mt-n1 mb-n6"
                    label="ИМН"
                    :input-value="item.settings.useMedicalProducts"
                    @change="
                      (value) =>
                        changeTypes(item.userId, 'useMedicalProducts', value)
                    "
                  ></v-switch>
                  <!-- v-if="item.organizationUseOptics" -->
                  <v-switch
                    color="primary"
                    class="pa-2 mt-n1 mb-n6"
                    label="Косметика"
                    :input-value="item.settings.useCosmetic"
                    @change="
                      (value) => changeTypes(item.userId, 'useCosmetic', value)
                    "
                  ></v-switch>
                </v-layout>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";

import { Icon } from "@/helpers";

export default {
  props: {
    organizationUsers: Array,
  },
  computed: {},
  methods: {
    ...mapActions({
      updateUserSettings: "users/UPDATE_USER_SETTINGS",
    }),
    changeTypes(userId, key, value) {
      this.updateUserSettings({ userId, key, value });
    },
  },
  data: () => ({
    icons: {
      tooltipAccount: Icon.tooltipAccount,
    },
  }),
  mounted() {},
};
</script>
